/* @flow */

export const getMetaNodeValue = (name: string): string | null => {
  const elt = document.querySelector(`meta[name="${name}"]`);
  if (elt instanceof HTMLMetaElement) {
    return elt.content;
  }
  return null;
};

export const getOpportunityId = (): string => {
  const partnerSource =
    new URLSearchParams(window.location.search).get("partner_source") || "";

  return partnerSource.replace(/^referrer_id[=:]/, "").split("_")[0];
};
